export default __webpack_public_path__ + "static/Asbury-020b34c3cd032db36ffac85c2b2298fc.svg";